/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

const RouteEnum = {
  HOME: "/",
  NOT_FOUND: "/not-found",
  LOGIN: "/login",
  SIGNUP: "/signup",
  REGISTER: "/register",
  UPLOADING_FILES: "/upload",
  PARSED_FILES: "/imported",
  PARSED_FILES_VALIDATION: "/parsed-files-validation",
  PARSED_FILES_VIEW_VALIDATION: "/hp-finder",
  PARSED_FILES_VIEW_HISTORY: "/archive",
  EDIT_PROFILE: "/edit-profile",
  CONFIG: "/watchlist",
  CUSTOMERS: "/customers",
  COMPANY: "/company",
  ADMIN: "/admin",
  AUDIT: "/audit",
  ACCEPT_INVITE: "/accept-invite",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_VERIFY: "/reset-password/verify",
  RESET_PASSWORD_CONFIRM: "/reset-password/confirm",
  MFA_VERIFY: "/mfa-verify",
  MFA_SETUP: "/mfa-setup",
  ONBOARDING_CREATE_COMPANY: "/onboarding/create-company",
  ONBOARDING_PENDING_APPROVAL: "/onboarding/pending-approval",
  STAFF_CONSULTANTS: "/staff/consultants",
  ANALYTICS: "/analytics",
  WHATS_NEW: "/whats-new",
};

export default RouteEnum;
